import React, { useState, useEffect, useRef, Fragment } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridColumnMenu, useGridApiRef, gridFilteredSortedRowIdsSelector, GRID_CHECKBOX_SELECTION_COL_DEF, gridFilterableColumnLookupSelector, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer, toast } from 'react-toastify';
import { formatShorthand, formatPhone } from '../../common/utils';
import LeadNamesInGrid from '../../containers/Loans/LeadNamesInGrid';
import { ModalCtx } from '../../contexts';
import AddToGroup from '../../components/Modals/AddToGroup';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import { singleSelectQuickFilter } from '../../common/utils';
import { update } from '../../common/api';
import NoteInGrid from '../Contacts/NoteInGrid';
import TaskInGrid from '../Contacts/TaskInGrid';
import Toolbar from './toolbar';
import LaunchPhoneBurner from '../../components/Modals/LaunchPhoneBurner';


import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';


function useQuery() {
    return new URLSearchParams( useLocation().search );
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const PAOpps = ( { orgId, aid, uid, user, grids, viewing, canExport, stack, loans, contacts, opps, tasks, notes, status, setDatagridWidth, setDatagridOrder } ) => {
    const [ trx, setTrx ] = useState( 0 );
    const [ vol, setVol ] = useState( 0 );
    const [ rev, setRev ] = useState( 0 );
    const [ stages, setStages ] = useState( [] );
    const [ loading, setLoading ] = useState( true );
    const [ pa, setPAs ] = useState( [] );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ filterModel, setFilterModel ] = useState( { items: [] } );
    const [ q, setQ ] = useState( '' );
    const [ classLogic, setClassLogic ] = useState( '' );
    const [ rowModesModel, setRowModesModel ] = useState( {} );
    const [ usingFilter, setUsingFilter ] = useState( false );
    const [ filterName, setFilterName ] = useState( '' );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();

    const location = useLocation();

    const query = useQuery();

    const handleColumnWidthChange = async ( { colDef, width } ) => {
        const datagrid = 'pas';

        let newWidths = {};
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newWidths[col.field] = col.width;
            }
        } );
        setDatagridWidth( { grid: datagrid, values: newWidths, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-width', uid, {
            grid: datagrid,
            values: newWidths,
            fn: filterName
        } );
    }

    const handleColumnOrderChange = async ( params ) => {
        const datagrid = 'pas';

        const newOrder = [];
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newOrder.push( col.field );
            }
        } );
        setDatagridOrder( { grid: datagrid, values: newOrder, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-order', uid, {
            grid: datagrid,
            values: newOrder,
            fn: filterName
        } );
    }

    const formatName = ( cid ) => {
        const r = contacts[cid]; // cl.find( f => f.cid === cid );
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    };

    const gridHelpers = {
        valueGetter: {
            borrowers: ( { row } ) => {
                let v = [];
                if ( row.borrowers ) {
                    row.borrowers.forEach( b => {
                        const bor = contacts[b.cid];
                        if ( bor ) {
                            v.push( bor.name );
                        }
                    } );
                }
                return v.join( ', ' );
            },
            cobo: ( { row } ) => {
                let v = [];
                if ( row.borrowers ) {
                    row.borrowers.forEach( b => {
                        const bor = contacts[b.cid];
                        if ( bor && bor.firstnamePartner1 ) {
                            v.push( `${bor.firstnamePartner1} ${bor.lastnamePartner1}` );
                        }
                    } );
                }
                return v.join( ', ' );
            },
            phoneBorr: ( { row } ) => {
                let p;  
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneCoBo: ( { row } ) => {
                let p;  
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.phonePartner1 && c.phonePartner1.length ) {
                        p = c.phonePartner1;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneBA: ( { row } ) => {
                let p;  
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneLA: ( { row } ) => {
                let p;  
                if ( row.laId ) {
                    const c = contacts[row.laId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            emailBorr: ( { row } ) => {
                let e;
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            emailCoBo: ( { row } ) => {
                let e;
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.emailPartner1 && c.emailPartner1.length ) {
                        e = c.emailPartner1;
                    }
                }
                return ( e ) ? e : null;
            },
            emailBA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            emailLA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            ooeBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.optoutEmail ) {
                        oo = c.optoutEmail;
                    }
                }
                return ( oo );
            },
            oocBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.optoutCall ) {
                        oo = c.optoutCall;
                    }
                }
                return ( oo );
            },
            oosBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.optoutSms ) {
                        oo = c.optoutSms;
                    }
                }
                return ( oo );
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value );
                    if ( !value.match( 'T' ) ) {
                        d.setDate( d.getDate() + 1 );
                    }
                }
                return ( d ) ? d : null;
            },
            referral: ( { row } ) => {
                let n;
                if ( row.referredById ) {
                    n = formatName( row.referredById );
                }
                return n;
            },
            salesRep: ( { row } ) => {
                let n;
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c ) {
                        n = c.salesRepId;
                    }
                }
                return n;
            },
            latestClosedTask: ( { row } ) => {
                return row.lastTask;
            },
            latestNote: ( { row } ) => {
                return row.lastNote;
            }
        },
        renderCell: {
            loanname: ( params ) => <Link to={`/loan/${params.row.id}`}>{params.value}</Link>,
            borrowers: ( { row } ) => <LeadNamesInGrid row={row} />,
            cobo: ( { value } ) => {
                return ( value ) ? value : null;
            },
            phone: ( { value } ) => {
                return ( value ) ? <a href={`tel:${value}`}>{value}</a> : null;
            },
            email: ( { value } ) => {
                return ( value ) ? <a href={`mailto:${value}`}>{value}</a> : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            contact: ( { value } ) => {
                let l;
                if ( value ) {
                    const c = contacts[value];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            fileNum: ( { row } ) => {
                return ( row.lid && row.fileNum ) ? <Link to={`/loan/${row.lid}`}>{row.fileNum}</Link> : null;
            },
            referral: ( { row } ) => {
                let l;
                if ( row.referredById ) {
                    l = <Link to={`/contact/${row.referredById}`}>{ formatName( row.referredById ) }</Link>
                }
                return l;
            },
            latestClosedTask: ( { value } ) => {
                return <TaskInGrid task={value} />;
            },
            latestNote: ( { value } ) => {
                return <NoteInGrid note={value} />;
            }
        },
        valueFormatter: {
            phone: ( { value } ) => {
                return ( value ) ? value : null;
            },
            email: ( { value } ) => {
                return ( value ) ? value : null;
            },
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            contact: ( { value } ) => {
                let n;
                if ( value ) {
                    const c = contacts[value];
                    if ( c ) {
                        n = formatName( c.cid );
                    }
                }
                return n;
            },
            referral: ( { value } ) => {
                return ( value ) ? value : '';
            },
            latestClosedTask: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            },
            latestNote: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };
    
    const containerRef = useRef();
    const titleRef = useRef();
    const numbersRef = useRef();

    const gridRef = useGridApiRef();

    const updateKPIs = ( model, details ) => {
        const visibleRows = gridFilteredSortedRowIdsSelector( gridRef );
        const rows = pa.filter( d => visibleRows.includes( d.loid ) );
        setTrx( rows.length );

        let v = 0;
        let rev = 0;
        rows.forEach( r => {
            if ( r.paMaxPurchPrice ) {
                let amt = r.paMaxPurchPrice;
                if ( typeof( amt ) === 'string' ) {
                    amt = amt.replace( '$', '' );
                    amt = amt.replace( /,/g, '' );
                    amt = amt.replace( /\.\d\d/, '' );
                    amt = Number( amt );
                }
                v += amt;
            }
            if ( r.revenue ) {
                let amt = r.revenue;
                if ( typeof( amt ) === 'string' ) {
                    amt = amt.replace( '$', '' );
                    amt = amt.replace( /,/g, '' );
                    amt = amt.replace( /\.\d\d/, '' );
                    amt = Number( amt );
                }
                rev += amt;
            }
        } );
        setVol( v );
        setRev( rev );
    }

    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleModal = async ( t ) => {
        let shouldOpen = true;

        const list = [];
        const loids = [];
        const allCids = [];
        const emailCids = [];
        const phoneCids = [];
        const uniqueEmails = new Set();
        const uniquePhones = new Set();
        selectedRows.forEach( loid => {
            loids.push( loid );
            const lo = opps[loid];
            const c = contacts[lo.relationships?.[0]?.cid];
            if ( c ) {
                list.push( c );
                allCids.push( c.cid );
                if ( c.email && c.email.length ) {
                    if ( !uniqueEmails.has( c.email.toLowerCase() ) && c.optoutEmail !== true ) {
                        uniqueEmails.add( c.email.toLowerCase() );
                        emailCids.push( c.cid );
                    }
                }
                let p = c.phoneMobile || c.phone || c.phoneWork || c.phoneHome;
                if ( p && p.length ) {
                    p = formatPhone( p );
                    if ( !uniquePhones.has( p ) && c.optoutSms !== true ) {
                        uniquePhones.add( p );
                        phoneCids.push( c.cid );
                    }
                }
            }
        } );
        
        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} clist={emailCids} objType='contact' aid={viewing[0]} /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} clist={phoneCids} objType='contact' /> );
                break;
    
            case 'list':
                setModal( <AddToGroup close={closeModal} itemType='contacts' items={allCids} aid={viewing[0]} /> );
                break;
    
            case 'event':
                setModal( <AddEvent close={closeModal} contacts={list} /> );
                break;

            case 'phoneburner':
                setModal( <LaunchPhoneBurner close={closeModal} type='leads' data={loids} /> );
                break;
    
            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const getRowClassName = ( params ) => {
        let cn = '';
        // console.log( classLogic );
        if ( classLogic ) {
            eval( classLogic );
        }
        return cn;
    }

    useEffect( () => {
        document.title = 'Third Floor - Pre-Approved Borrowers';
    }, [] );
    
    useEffect( () => {
        let filters = {};
        for ( let [ key, value ] of query.entries() ) {
            filters[key] = value;
        }

        if ( grids && grids.pas && !gridReady ) {
            let activeFilter = false;
            setFilterName( '' );

            let storedCols = JSON.parse( grids.pas.cols );
            if ( filters.fn && grids.pas.filters && grids.pas.filters[filters.fn] ) {
                if ( grids.pas.filters[filters.fn].cols ) {
                    activeFilter = true;
                    setUsingFilter( true );
                    setFilterName( filters.fn );
                    storedCols = JSON.parse( grids.pas.filters[filters.fn].cols );
                }

                if ( grids.pas.filters[filters.fn].criteria ) {
                    const crit = JSON.parse( grids.pas.filters[filters.fn].criteria );
                    setFilterModel( { items: crit } );
                }

                if ( grids.pas.filters[filters.fn].className ) {
                    setClassLogic( grids.pas.filters[filters.fn].className );
                }
            } else {
                if ( filters.crit ) {
                    const crit = JSON.parse( filters.crit );
                    setFilterModel( { items: crit } );
                }
                if ( grids.pas.className ) {
                    setClassLogic( grids.pas.className );
                }
            }

            if ( storedCols ) {
                let cols = storedCols.map( c => {
                    if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                        c.renderCell = gridHelpers.renderCell[c.renderCell];
                    }
                    if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                        c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                    }
                    if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                        c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                    }
                    if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                        c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                    }
                    
                    if ( user && user.datagrids && user.datagrids.pas ) {
                        if ( activeFilter ) {
                            if ( user.datagrids.pas.filters && user.datagrids.pas.filters[filters.fn] && user.datagrids.pas.filters[filters.fn].colSize && user.datagrids.pas.filters[filters.fn].colSize[c.field] ) {
                                c.width = user.datagrids.pas.filters[filters.fn].colSize[c.field];
                            }
                        } else if ( user.datagrids.pas.colSize && user.datagrids.pas.colSize[c.field] ) {
                            c.width = user.datagrids.pas.colSize[c.field];
                        }
                    }
                    // c.editable = true;
                    return c;
                } );

                if ( user && user.datagrids && user.datagrids.pas ) {
                    if ( activeFilter ) {
                        if ( user.datagrids.pas.filters && user.datagrids.pas.filters[filters.fn] && user.datagrids.pas.filters[filters.fn].colOrder && user.datagrids.pas.filters[filters.fn].colOrder.length ) {
                            cols = user.datagrids.pas.filters[filters.fn].colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    } else {
                        if ( user.datagrids.pas.colOrder && user.datagrids.pas.colOrder.length ) {
                            cols = user.datagrids.pas.colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    }
                }

                setCols( cols );
                setGridReady( true );
            }
        }
    }, [ user, query, grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady ] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - numbersRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        if ( opps ) {
            const stats = status.filter( s => s.queue === 'pa' ).map( m => m.value );
            let list = [];
            Object.keys( opps ).forEach( o => {
                const opp = opps[o];
                if ( opp && stats.includes( opp.status ) ) {
                    const lid = opp.relationships?.[0]?.lid;
                    let c = contacts[opp.relationships?.[0]?.cid];
                    if ( c && viewing.includes( c.aid ) ) {
                        const tmpNotes = [];
                        const tmpTasks = [];
                            
                        Object.keys( notes ).forEach( nid => {
                            const n = notes[nid];
                            const yes = n.assoc?.find( f => f.cid === c.cid );
                            if ( yes ) {
                                tmpNotes.push( n );
                            }
                        } );
                        tmpNotes.sort( ( a, b ) => {
                            const ad = new Date( a.createdDate );
                            const bd = new Date( b.createdDate );
                            return bd.getTime() - ad.getTime();
                        } );

                        Object.keys( tasks ).forEach( tid => {
                            const t = tasks[tid];
                            if ( t.status !== 'Completed' ) {
                                return;
                            }
                            const yes = t.assoc?.find( f => f.cid === c.cid );
                            if ( yes ) {
                                tmpTasks.push( t );
                            }
                        } );
                        tmpTasks.sort( ( a, b ) => {
                            const ad = new Date( a.completedDate ? a.completedDate : a.createdDate );
                            const bd = new Date( b.completedDate ? b.completedDate : b.createdDate );
                            return bd.getTime() - ad.getTime();
                        } );

                        const l = loans[lid];
                        const borrs = ( l ) ? l.borrowers : opp.relationships;
                        borrs.sort( ( a, b ) => {
                            if ( a.label === 'Primary' ) {
                                return -1;
                            }
                            if ( b.label === 'Primary' ) {
                                return 1;
                            }
                            return 0;
                        } );
                        c = contacts[borrs[0].cid];
                        list.push( {
                            ...opp,
                            lid: ( l ) ? l.lid : null,
                            borrowers: borrs,
                            paDate: ( l ) ? l.paDate : null,
                            paMaxPurchPrice: ( l ) ? l.paMaxPurchPrice : 0,
                            lowPurchPrice: ( l ) ? l.lowPurchPrice : 0,
                            highPurchPrice: ( l ) ? l.highPurchPrice : 0,
                            maxPurchPrice: ( l ) ? l.maxPurchPrice : 0,
                            revenue: ( l ) ? l.revenue : 0,
                            loanType: ( l ) ? l.loanType : null,
                            referredById: ( c && c.referredById ) ? c.referredById : null,
                            lastTask: tmpTasks[0],
                            lastNote: tmpNotes[0],
                            fileNum: ( l ) ? l.fileNum : null,
                            loanSource: ( l ) ? l.source : null,
                            loanStage: ( l ) ? l.stage : null,
                            rank: ( c && c.rank ) ? c.rank : null,
                        } );
                    }
                }
            } );
            list.sort( ( a, b ) => {
                let ad = new Date( a.oppDate );
                let bd = new Date( b.oppDate );

                if ( a.paDate ) {
                    ad = new Date( a.paDate );
                }
                if ( b.paDate ) {
                    bd = new Date( b.paDate );
                }
                return bd.getTime() - ad.getTime();
            } );
            setPAs( list );
            setLoading( false );
        }
    }, [ opps, status, loans, contacts, tasks, notes, viewing ] );

    useEffect(() => {
        if ( location.search !== q ) {
            setGridReady( false );
            setFilterModel( { items: [] } );
            setClassLogic( '' );
            setQ( location.search );
        }
    }, [ location.search, q ] ); 

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );
    
    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>Pre-Approved Borrowers</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Card.Subtitle className='py-3' ref={numbersRef}>
                              <Row className='text-center'>
                                <Col>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-value'>{trx}</Col>
                                    </Row>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-label'>Pre-Approvals</Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-value'>${formatShorthand( vol, 2 )}</Col>
                                    </Row>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-label'>Potential Purchase Volume</Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-value'>${formatShorthand( rev, 2 )}</Col>
                                    </Row>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-label'>Potential Revenue</Col>
                                    </Row>
                                </Col>
                              </Row>
                            </Card.Subtitle>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ModalCtx.Provider value={ { openModal, closeModal, setModal } }>
                                        { 
                                            ( gridReady ) ? (
                                                <DataGridPro
                                                    apiRef={gridRef}
                                                    initialState={ { 
                                                        // pinnedColumns: { left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ] }
                                                    } }
                                                    getRowId={ ( r ) => r.loid }
                                                    loading={ loading }
                                                    rows={ pa }
                                                    columns={ cols }
                                                    density='compact'
                                                    checkboxSelection
                                                    disableSelectionOnClick
                                                    slots={ { 
                                                        toolbar: Toolbar,
                                                        columnMenu: customColumnMenu 
                                                    } }
                                                    slotProps={ { toolbar: {
                                                        selectedRows: selectedRows, 
                                                        handleModal: handleModal, 
                                                        hasTxting: hasTxting, 
                                                        hasPhoneBurner: hasPhoneBurner, 
                                                        canExport: canExport,
                                                        viewing: viewing
                                                    } } }
                                                    onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                                    onColumnWidthChange={ handleColumnWidthChange }
                                                    onColumnOrderChange={ handleColumnOrderChange }
                                                    filterModel={ filterModel }
                                                    onFilterModelChange={ ( newFilterModel ) => setFilterModel( newFilterModel ) }
                                                    getRowClassName={ getRowClassName }
                                                    editMode='row'
                                                    onStateChange={ updateKPIs }
                                                />
                                            ) : (
                                                null
                                            )
                                        }
                                    </ModalCtx.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    loans: state.loans.byId,
    contacts: state.contacts.byId,
    opps: state.leadopps.byId,
    tasks: state.tasks.byId,
    notes: state.notes.byId,
    status: state.user.meta.global.picklist.status
} );
  
const mapDispatch = ( dispatch ) => ( {
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder
} );
  
export default connect( mapProps, mapDispatch )( PAOpps );